var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-input',{staticClass:"inputCurrency",class:{
      inputCurrencySaisie: _vm.isInputActive,
      inputCurrencyBackgroundGrid3: _vm.bg3
    },attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"blur":function($event){_vm.isInputActive = false},"focus":function($event){_vm.isInputActive = true}},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }